import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCaptureControlEquipment } from "../../../hooks/Capture";
import ControlEquipments from "../ControlEquipment/ControlEquipments";

interface ControlEquipmentTabProps {
  captureId: string;
  handleError: (error: any) => void;
  canEdit: boolean;
}

const ControlEquipmentTab: React.FC<ControlEquipmentTabProps> = ({ captureId, handleError, canEdit }) => {
  const { controlEquipmentsData, isPending, createControlEquipment, updateControlEquipment, deleteControlEquipment } = useCaptureControlEquipment(captureId);

  if (isPending && controlEquipmentsData.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ControlEquipments
      controlEquipmentsData={controlEquipmentsData}
      canEdit={canEdit}
      onCreate={async (values) => {
        await createControlEquipment(values).catch(handleError);
      }}
      onUpdate={async (id, values) => {
        await updateControlEquipment({ equipmentId: id, values }).catch(handleError);
      }}
      onDelete={async (id) => {
        await deleteControlEquipment(id).catch(handleError);
      }}
    />
  );
};

export default ControlEquipmentTab;
